




























import {Vue, Component, Watch} from 'vue-property-decorator'
import dataProxy from "@/services/data-proxy.service";
import mixins from "vue-class-component"
import {ComponentBaseMixin} from "@/mixins/component-base.mixin";
import {formatPrice} from "@/utils/formatters";

@Component({})
export default class PregledZaliha extends mixins(ComponentBaseMixin) {
    zalihe = [];
    columns = [];

    skladisteId = '';

    options = {
        search: true,
        pagination: true
    };

    async created() {
        this.columns = [
            {field: 'sifra', title: this.$i18n.t('sifra')},
            {field: 'kataloskiBroj', title: this.$i18n.t('kataloskiBroj')},
            {field: 'naziv', title: this.$i18n.t('naziv')},
            {field: 'nabavnaCena', title: this.$i18n.t('prosecnaNabavnaCena'), align: 'right', formatter: formatPrice},
            {field: 'poslednjaNabavnaCena', title: this.$i18n.t('poslednjaNabavnaCena'), align: 'right', formatter: formatPrice},
            {field: 'minZaliha', title: this.$i18n.t('minZaliha'), align: 'right', formatter: formatPrice},
            {field: 'maxZaliha', title: this.$i18n.t('maxZaliha'), align: 'right', formatter: formatPrice},
            {field: 'kolicina', title: this.$i18n.t('zaliha'), align: 'right', formatter: formatPrice},
            {field: 'vrednost', title: this.$i18n.t('vrednost'), align: 'right', formatter: formatPrice}
        ]
    }

    @Watch('skladisteId') async onSkladisteChange(value: number) {
        this.zalihe = await this.loadData(() => dataProxy.vratiZaliheRezervnihDelova(value))();
        console.log(value);
        console.log(this.zalihe.length);
    }

    zaliheDummyData() {
        this.zalihe = [
            {
                skladiste: 'Novi Sad',
                sifra: 'MOTO0856',
                kataloskiBroj: '71-33969-00',
                naziv: 'ZAPTIVAC KARTERA REINZ IVECO-STRALIS',
                nabavnaCena: '3432',
                poslednjaNabavnaCena: '3432',
                minZaliha: '1',
                maxZaliha: '0',
                zaliha: '0',
                vrednost: '3432'
            },
            {
                skladiste: 'Sombor',
                sifra: 'MOTO1732',
                kataloskiBroj: '500350785',
                naziv: 'PUMPA VODE IVECO',
                nabavnaCena: '115500',
                poslednjaNabavnaCena: '115500',
                minZaliha: '0',
                maxZaliha: '0',
                zaliha: '0',
                vrednost: '0'
            }
        ]
    }

}
